module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/testimonials/agung-sentausa-f30bf24e05febf004c93e96f541eb0ff.jpg";